import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

export default function ClientSetPasswordPage() {
  const { principal } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { setErr("Min 6 characters"); return; }
    if (pw !== confirm) { setErr("Passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/client-set-password", { new_password: pw });
      toast.success("Password set. Please log in.");
      window.location.href = "/login";
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] p-4">
      <form onSubmit={submit} className="iz-card p-8 max-w-sm w-full" data-testid="client-set-pw-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-[#d4af37]/10 border border-[#d4af37] flex items-center justify-center">
            <Lock className="w-4 h-4 text-[#d4af37]"/>
          </div>
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#d4af37]">First Login</p>
            <h1 className="font-display text-2xl text-white">Set your password</h1>
            <p className="text-[11px] text-gray-500 font-mono">{principal?.email}</p>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-gray-400 mb-2">New password</label>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="iz-input" data-testid="new-pw" required/>
          </div>
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-gray-400 mb-2">Confirm password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="iz-input" data-testid="confirm-pw" required/>
          </div>
          {err && <div className="text-sm text-red-400 border border-red-500/30 bg-red-500/5 rounded-md px-3 py-2">{err}</div>}
          <button type="submit" disabled={saving} className="iz-btn-primary w-full" data-testid="set-pw-submit">
            {saving ? "Saving…" : "Set password"}
          </button>
        </div>
      </form>
    </div>
  );
}
